export const EnrollPasskeyModalTestIds = {
  MODAL: 'enroll-passkey.modal',
  NICKNAME_INPUT: 'enroll-passkey.nickname-input',
  CLOSE_BUTTON: 'enroll-passkey.close-button',
  ACCEPT_BUTTON: 'enroll-passkey.accept-button',
};
